import React, { memo, useContext } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { ChatContext } from 'context/Context';
import PropTypes from 'prop-types';

const ReportChat = ({ id, message }) => {
    const { setShowReportModal, setReportChat } = useContext(ChatContext);
    return (
        <>
            <div className='top-0 end-0 position-absolute me-0 mt-0'>
                <FontAwesomeIcon
                    size='lg'
                    icon={faInfoCircle}
                    className='text-info cursor-pointer'
                    title='Click to report this message'
                    onClick={() => {
                        setShowReportModal(true);
                        setReportChat({ id, message });
                    }}
                />
            </div>
        </>
    )
}

ReportChat.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    id: PropTypes.number
};

export default memo(ReportChat);